import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "serp__filter-filter--container q-py-1 q-shadow-sm q-my-2 q-mb-3 q-rounded-3 q-bg-white" }
const _hoisted_2 = { class: "q-accordion-item" }
const _hoisted_3 = ["aria-expanded", "aria-controls"]
const _hoisted_4 = ["id", "aria-labelledby"]
const _hoisted_5 = { class: "q-accordion-body q-p-1" }
const _hoisted_6 = {
  key: 0,
  class: "q-input-group q-input-group-sm q-my-2 filter-search__container"
}
const _hoisted_7 = ["placeholder"]

import {computed, ref, inject} from 'vue'
import {SmartSearchTranslationsInterface} from '@/core/types'

// Podrzędne komponenty
import FilterCheckboxRecursive from './FilterItem/FilterCheckboxRecursive.vue'
import BoxItem from './FilterItem/BoxItem.vue'
import InputRangeItem from './FilterItem/InputRangeItem.vue'
import MultiRangeSlider from './FilterItem/MultiRangeSlider.vue'

// Props

export default /*@__PURE__*/_defineComponent({
  __name: 'FilterItemContainer',
  props: ['filter', 'filterCollapsed'],
  setup(__props) {

const props = __props

const isCollapsed = ref(props.filterCollapsed || false)

function toggleAccordion() {
  isCollapsed.value = !isCollapsed.value
}

const lengthOfAggregate = computed(() => props?.filter?.data?.values?.length || 0)


// Tłumaczenia (jak w Twoim kodzie)
const SmartSearchTranslations = inject<SmartSearchTranslationsInterface>('SmartSearchTranslations')!

// Klasy CSS do <ul>
const computedClass = computed(() => {
  if (props.filter.type === 'box') {
    return `q-p-0 serp__filter-item--${props.filter.type}`
  }
  return [
    'serp__filter-item--group',
    `serp__filter-item--${props.filter.type}`,
    'q-list-group',
    'q-list-group-flush',
    'q-list-group-collapse',
  ]
})

const computedClassContainer = computed(() => {
  return [`filter__item-container-${props.filter.type}`]
})

// SEARCH
const searchQuery = ref('')

// 1) Definiujemy rekurencyjną funkcję filtrującą
function filterCategoriesRecursive(values: any[], query: string) {
  // jeżeli brak query => nie filtrujemy
  if (!query) {
    return values
  }
  // w przeciwnym wypadku mapujemy i filtrujemy
  return values
      .map(item => {
        // Czy ten element pasuje w labelu?
        const match = item.label.toLowerCase().includes(query)
        // Czy istnieją podkategorie?
        let subItems = []
        if (item.aggregations && item.aggregations.length) {
          // Rekurencyjnie filtrujemy potomków
          subItems = filterCategoriesRecursive(item.aggregations, query)
        }

        // Zostawiamy ten element, jeśli:
        // a) Sam pasuje (match),
        // b) albo jego któryś potomek pasuje (subItems niepuste).
        if (match || subItems.length > 0) {
          // Zwracamy nowy obiekt z *przefiltrowaną* listą subItems
          return {
            ...item,
            aggregations: subItems,
          }
        } else {
          // W przeciwnym wypadku odrzucamy go (undefined)
          return undefined
        }
      })
      // wyrzucamy te, które są undefined
      .filter(Boolean)
}

function filterFlat(values: any[], query: string) {
  if (!query) {
    return values
  }
  return values.filter(item =>
      item.label.toLowerCase().includes(query)
  )
}

// 2) computed, które zwraca przefiltrowane dane
const filteredValues = computed(() => {
  // pobieramy oryginalną listę
  const allValues = props.filter.data.values || []

  // w zależności czy to kategorie (rekurencyjne), czy np. box
  // możemy przyjąć:
  if (props.filter.type === 'category' || props.filter.type === 'checkbox') {
    return filterCategoriesRecursive(allValues, searchQuery.value.toLowerCase())
  } else if (props.filter.type === 'box') {
    // Do "box" wystarczy płaska filtracja, np.:
    return filterFlat(allValues, searchQuery.value.toLowerCase())
  }
  // Inne typy (range, slider) - tu nie filtrujemy
  return allValues
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h6", {
        class: _normalizeClass(["q-accordion-header q-position-relative serp__filter-item--header q-accordion-button q-rotatable q-p-3 q-py-2 q-mt-0 q-fs-6 q-my-0 q-fw-semibold", {'q-collapsed': isCollapsed.value, 'q-rotated': !isCollapsed.value}]),
        onClick: toggleAccordion,
        "aria-expanded": !isCollapsed.value.toString(),
        "aria-controls": __props.filter.field
      }, _toDisplayString(__props.filter.label), 11, _hoisted_3),
      _createElementVNode("div", {
        id: __props.filter.field,
        class: _normalizeClass(["q-accordion-collapse", {'q-collapse': isCollapsed.value, 'q-show': !isCollapsed.value}]),
        "aria-labelledby": __props.filter.field
      }, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", {
            class: _normalizeClass(["serp__filter-item--container q-container-fluid", computedClassContainer.value])
          }, [
            _createElementVNode("ul", {
              class: _normalizeClass([computedClass.value, "q-my-1"])
            }, [
              ((__props.filter.type !== 'range' && __props.filter.type !== 'rangeSlider')
                  && (__props.filter.type !== 'category' && lengthOfAggregate.value >= 6)
                  || (__props.filter.type === 'category' && lengthOfAggregate.value >= 2))
                ? (_openBlock(), _createElementBlock("li", _hoisted_6, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "q-form-control filter-search__input",
                      placeholder: _unref(SmartSearchTranslations).serp.filterSearchHeader,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchQuery).value = $event))
                    }, null, 8, _hoisted_7), [
                      [_vModelText, searchQuery.value]
                    ])
                  ]))
                : _createCommentVNode("", true),
              (__props.filter.type === 'checkbox' || __props.filter.type === 'category')
                ? (_openBlock(), _createBlock(FilterCheckboxRecursive, {
                    key: 1,
                    values: filteredValues.value,
                    field: __props.filter.field
                  }, null, 8, ["values", "field"]))
                : _createCommentVNode("", true),
              (__props.filter.type === 'box')
                ? (_openBlock(), _createBlock(BoxItem, {
                    key: 2,
                    filterDataValues: filteredValues.value,
                    field: __props.filter.field
                  }, null, 8, ["filterDataValues", "field"]))
                : _createCommentVNode("", true),
              (__props.filter.type === 'range')
                ? (_openBlock(), _createBlock(InputRangeItem, {
                    key: 3,
                    filterData: __props.filter.data,
                    field: __props.filter.field
                  }, null, 8, ["filterData", "field"]))
                : _createCommentVNode("", true),
              (__props.filter.type === 'rangeSlider')
                ? (_openBlock(), _createBlock(MultiRangeSlider, {
                    key: 4,
                    filterData: __props.filter.data,
                    field: __props.filter.field
                  }, null, 8, ["filterData", "field"]))
                : _createCommentVNode("", true)
            ], 2)
          ], 2)
        ])
      ], 10, _hoisted_4)
    ])
  ]))
}
}

})